import { render, staticRenderFns } from "./ServiceChargeStatements.vue?vue&type=template&id=19940a59&scoped=true"
import script from "./ServiceChargeStatements.vue?vue&type=script&lang=js"
export * from "./ServiceChargeStatements.vue?vue&type=script&lang=js"
import style0 from "./ServiceChargeStatements.vue?vue&type=style&index=0&id=19940a59&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19940a59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCardSubtitle,VDataTable,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon})
